export default __webpack_public_path__ + "static/media/us.5506ca16.png";